import Client from './Client';

export default Client;
